import React, {forwardRef, useImperativeHandle} from "react";
import {useQueryClient} from "react-query";
import {FormGroup, List, ListItem, ListItemIcon, ListItemText} from '@material-ui/core';
import {Filter1, Filter2, Filter3} from "@material-ui/icons";
import { LabelledPaper } from '../../../controls';
import useAirportSlotRequirements from "../../../services/airports/useAirportSlotRequirements";

const nilRequirements = [
  {seasonName: "", slotLevel: ""}, {seasonName: "Slot not required", slotLevel: 0}, {seasonName: "", slotLevel: ""}, {seasonName: "", slotLevel: ""}
]

const toTitleCase = (str) => {
  return str.replace(
    /\w\S*/g,
    function(txt) {
      return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
    }
  );
}

const AirportSlotRequirementList = (props) => {

  const queryClient = useQueryClient();
  const extraKeys = [props.airportCode];
  const displayMode = props.displayMode || "LIST";
  const airportName = props.airportName || "";
  const requirements = useAirportSlotRequirements({queryClient, extraKeys, useCache: true});

  const listItems = requirements.data && Array.isArray(requirements.data) && requirements.data.length > 0 ? requirements.data : nilRequirements;
  const slotInfo = [];
  if (listItems === nilRequirements) {
    slotInfo.push("Slot not required");
    if (props.airportCode && props.onChange && displayMode !== "LIST") {
      props.onChange({slotRequired: false, slotRequirements: []});
    }
  } else {
    listItems.forEach(item=> slotInfo.push(`${item.seasonCode} - ${toTitleCase(item.slotLevel)}`));
    if (props.airportCode && props.onChange && displayMode !== "LIST") {
      props.onChange({slotRequired: true, slotRequirements: listItems});
    }
  }

  return (
    <LabelledPaper  label={`Slot Requirements${displayMode === "STRING" ? " at " + airportName: ""}`} style={{marginLeft: `${displayMode === "LIST" ? 20 : 0}`}}>
      <FormGroup key="FGL-airportslots" style={{padding: "2px 2px 2px 2px"}}>
        {
          displayMode === "LIST"
            ?
              <List dense={true} disablePadding >
                {listItems
                  ?
                  listItems.map(item=> (
                    <ListItem>
                      <ListItemText
                        primary={listItems === nilRequirements ? item.seasonName : `${item.seasonName} - ${toTitleCase(item.slotLevel)}`}
                      />
                      <ListItemIcon>
                        {item.slotLevel === 0 ? <Filter1/> : item.slotLevel === 1 ? <Filter2/> : item.slotLevel === 3 ? <Filter3/> : <></>}
                      </ListItemIcon>
                    </ListItem>
                  ))
                  :
                  <></>
                }
              </List>
            :
              <div style={{padding: "4px 4px 4px 4px"}}>
                {slotInfo.join(", ")}
              </div>
        }
      </FormGroup>
    </LabelledPaper>
  );
}

export default AirportSlotRequirementList;
